import React, { useCallback, useEffect, useState } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';

import { post } from 'jsx/utils/axiosWrapper';
import url from 'jsx/utils/urlWrapper';
import { REQUEST_BRAND } from 'jsx/utils/brand';

import InformationRequestStart from './components/informationRequestStart';
import InformationRequestConfirmation from './components/informationRequestConfirmation';
import InformationRequestForm, {
  FormDataType,
} from './components/informationRequestForm';
import Layout from './layout';
import { InformationRequestType, INFORMATION_REQUEST } from './constants';

const informationRequestRoutes = {
  start: '/information-request',
  form: '/information-request/form',
  confirmation: '/information-request/confirmation',
};

const InformationRequest: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    document.title = `${REQUEST_BRAND.displayName} - Personal Information Request`;
  }, []);

  const [requestType, setRequestType] = useState<InformationRequestType>(
    INFORMATION_REQUEST.download,
  );

  const selectRequestType = (type: InformationRequestType): void => {
    setRequestType(type);
    history.push(informationRequestRoutes.form);
  };

  const submitRequest = useCallback(
    (values: FormDataType): Promise<void> =>
      post(url(`api.informationRequests.${requestType}`), {
        ...values,
        requestType,
      }).then(() => history.push(informationRequestRoutes.confirmation)),
    [history, requestType],
  );

  return (
    <Layout>
      <Switch>
        <Route exact path={informationRequestRoutes.form}>
          <InformationRequestForm
            requestType={requestType}
            onSubmit={submitRequest}
          />
        </Route>
        <Route exact path={informationRequestRoutes.confirmation}>
          <InformationRequestConfirmation />
        </Route>
        <Route path={informationRequestRoutes.start}>
          <InformationRequestStart selectRequestType={selectRequestType} />
        </Route>
      </Switch>
    </Layout>
  );
};

export default observer(InformationRequest);
